import React, { useState, useMemo } from 'react';
import { Grid, Tooltip } from '@material-ui/core';
import BreadCrumbs from '../../../../Core/Controls/Breadcrumb';
import ReportGijgoGrid from '../../../internal/ReportsScreens/GijgoForReportsScreen';
import { SquareButton } from '../../../../Core/FormInput/AppButton';
import { Add } from '@material-ui/icons';
import EditIcon from '@material-ui/icons/Edit';
import ReactDOM from 'react-dom';
import DialogComp from '../../../../Core/Modal/dialogModal';
import AddUpdateEventTypes from './addUpdateEventTypes';

let styleObj = {
    backgroundColor: '#183B68',
    borderRadius: '20%',
    width: '32px',
    height: '32px',
    textAlign: 'center',
    padding: '0px 0px 0px 0px'
};

const crumbs = [
    { name: 'Home', path: '/' },
    { name: 'Event Types', path: '/', active: true }
];

const TCardEventTypes = () => {
    const [state, setState] = useState({
        isReload: new Date(),
        showModal: false,
        selectedEventTypeID: null
    });
    const handleClose = (shouldReload) => {
        setState((st) => ({
            ...st,
            showModal: false,
            selectedEventTypeID: null,
            isReload: shouldReload ? new Date() : st.isReload
        }));
    };

    const baseColumns = [
        {
            field: 'action',
            title: `Action`,
            filterable: false,
            sortable: false,
            width: '3%'
        },
        {
            field: 'tCardEventTypeDescription',
            title: `Description`,
            filterable: true,
            sortable: true,
            width: '40%'
        },
    ];

    const handelAddUpdate = (row = null) => {
        setState((st) => ({
            ...st,
            showModal: true,
            selectedEventTypeID: row ? row.tCardEventTypeID : null
        }));
    };
    const addButton = () => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ marginLeft: '5px' }}>
                <Tooltip title="Add Event Type" arrow>
                    <abbr style={{ textDecoration: 'none' }}>
                        <SquareButton style={styleObj} onClick={() => handelAddUpdate(null)}>
                            <Add fontSize="small" style={{ color: 'white' }} />
                        </SquareButton>
                    </abbr>
                </Tooltip>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editButton = () => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-evenly">
                <Tooltip title="Edit Event Type" arrow>
                    <abbr style={{ textDecoration: 'none' }}>
                        <SquareButton style={styleObj} onClick={() => handelAddUpdate(record)}>
                            <EditIcon fontSize="small" style={{ color: 'white' }} />
                        </SquareButton>
                    </abbr>
                </Tooltip>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');

        if (actionCol) {
            actionCol.renderer = editButton({});
        }

        return tempCols;
    }, []);

    const baseUrl = 'TCardEventTypes/TCardEventType_list';

    return (
        <div>
            <BreadCrumbs crumbs={crumbs} />
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <ReportGijgoGrid
                        dataConverter={(res) => ({
                            records: res?.data,
                            total: res?.data[0]?.total
                        })}
                        columns={columns}
                        getUrl={baseUrl}
                        isReload={state.isReload}
                        AddBtn={addButton}
                    />
                </Grid>
            </Grid>
            {state.showModal ? (
                <DialogComp overflow="auto" title={state.selectedEventTypeID ? 'Update Event Type' : 'Add Event Type'} fullWidth onClose={() => handleClose(false)}>
                    <AddUpdateEventTypes onClose={() => handleClose(true)} eventTypeID={state.selectedEventTypeID} />
                </DialogComp>
            ) : null}
        </div>
    );
};
export default TCardEventTypes;
